import React from "react";
import Slider from "react-slick";
import "./MediaCarousel.css";

function MediaCarousel() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 3000,   // 3 seconds
        // pauseOnHover: true
    };

    return (
            <Slider {...settings} className="my-slider">
                {/* Image Slide */}
                <div>
                    <img src="/images/Frame 5.jpg" alt="slide1"  className="all-journey-img" />
                </div>

                {/* Video Slide */}
                <div>
                    <video  className="journey-video" controls loop>
                        <source src="/EntryLevelJourney.mp4" type="video/mp4" />
                    </video>
                </div>

                <div>
                    <img src="/images/Frame 3.jpg" alt="slide3"  className="all-journey-img" id="img3" />
                </div>

                {/* Another Image */}
                {/* <div>
        <img src="/images/pic2.jpg" alt="slide2" width="100%" />
      </div> */}
            </Slider>
        
    );
}

export default MediaCarousel;
